<template>
  <div class="deposit text-center">
    <div class="f20 mar20-b text-left">{{ popupPrompt.desp }}</div>
    <div>
      <el-button class="mar60-l" plain v-if="popupPrompt.isShow" @click="setPopup">稍后缴费</el-button>
      <el-button type="primary" class="mar20-l f16" @click="toSetUp">去缴费</el-button>
    </div>
    <div class="red mar5-t" v-if="popupPrompt.isShow">点击稍后缴费后今日不再提示</div>
  </div>
</template>

<style lang="scss" scoped>
@import "./index.scss";
</style>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      enterprise: (state) => state["shop/shop"].enterprise,
    }),
  },
  data() {
    return {
      env: process.env,
      popupPrompt: {},
    };
  },
  created() {
    this.$store.commit("app/setShowTitle", false);
    this.$store.dispatch("setUp/getPopupPrompt").then((data) => {
      this.popupPrompt = data || {};
    });
  },
  methods: {
    setPopup() {
      this.$store.dispatch("setUp/setPopupPrompt").then((res) => {
        if (res.code === "0") {
          window.top.location = `${this.env.VUE_APP_HOME}trade/default`;
        }
      });
    },
    toSetUp() {
      this.$router.push(`/setup`);
    },
  },
};
</script>
